export type SopBias = 'Left' | 'Right' | 'Even' | 'N/A';

export interface SopBiasTheme {
  hex: string;
  bg: string;
  border: string;
  text: string;
  fill: string;
}

export const SOP_BIAS_THEME: Record<SopBias, SopBiasTheme> = {
  Left: {
    hex: '#8e44ad',
    bg: 'bg-primary/15',
    border: 'border-primary/60',
    text: 'text-primary',
    fill: 'fill-primary/20',
  },
  Right: {
    hex: '#ef4444',
    bg: 'bg-rose-500/15',
    border: 'border-rose-500/60',
    text: 'text-rose-300',
    fill: 'fill-rose-500/20',
  },
  Even: {
    hex: '#22c55e',
    bg: 'bg-emerald-500/15',
    border: 'border-emerald-500/60',
    text: 'text-emerald-300',
    fill: 'fill-emerald-500/20',
  },
  'N/A': {
    hex: '#71717a',
    bg: 'bg-slate-600/20',
    border: 'border-slate-500/60',
    text: 'text-slate-300',
    fill: 'fill-slate-500/20',
  },
};

export const SOP_ACCENT_THEME = {
  hypermobileHex: '#eab308',
  hypermobileBadge: 'bg-amber-500/15 border-amber-500/60 text-amber-300',
  invalidatedHex: '#ef4444',
  invalidatedBadge: 'bg-rose-500/15 border-rose-500/60 text-rose-300',
} as const;

export const SOP_SURFACE_THEME = {
  glass: 'bg-slate-800/70 backdrop-blur-sm border border-slate-700/50',
  glassMuted: 'bg-slate-900/55 backdrop-blur-sm border border-slate-700/40',
  cardRadius: 'rounded-xl',
  panelGap: 'gap-4',
} as const;

export const SOP_SECTION_ORDER = ['cervical', 'thorax', 'pelvis', 'femoral'] as const;

export const SOP_SECTION_LABELS: Record<(typeof SOP_SECTION_ORDER)[number], string> = {
  cervical: 'Head / Neck',
  thorax: 'Shoulders / Thorax',
  pelvis: 'Pelvis',
  femoral: 'Femoral / Legs',
};
